export const createException = ({ code, message = null, ...params }) => {
  return Object.assign(
    new Error(message || code),
    {
      code,
      ...params,
    }
  )
}